/** Keep the outer header group sticky so its section cannot scroll it away. */
class CustomStickyHeader extends HTMLElement {
  connectedCallback() {
    this.group = this.closest('#header-group');
    if (!this.group) return;
    this.controller = new AbortController();
    this.observer = new ResizeObserver(() => this.update());
    this.observer.observe(this);
    this.desktop = matchMedia('(min-width: 990px)');
    this.desktop.addEventListener('change', () => this.update(), { signal: this.controller.signal });
    this.update();
  }

  update() {
    const enabled = this.desktop.matches ? this.dataset.stickyDesktop : this.dataset.stickyMobile;
    this.group.toggleAttribute('data-custom-sticky-active', enabled === 'true');
    const announcement = this.querySelector('.custom-announcement-bar')?.getBoundingClientRect().height || 0;
    const logo = this.querySelector('.custom-header__center')?.getBoundingClientRect().height || 0;
    const hidden = this.dataset.stickyLevel === 'all' ? 0 : announcement +
      (this.desktop.matches && this.dataset.stickyLevel === 'navigation' ? logo : 0);
    this.group.style.setProperty('--custom-sticky-hidden', `${hidden}px`);
    this.group.style.setProperty('--custom-sticky-offset', `${Number(this.dataset.stickyOffset) || 0}px`);
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    this.group?.removeAttribute('data-custom-sticky-active');
    this.group?.style.removeProperty('--custom-sticky-hidden');
    this.group?.style.removeProperty('--custom-sticky-offset');
  }
}
if (!customElements.get('custom-sticky-header')) customElements.define('custom-sticky-header', CustomStickyHeader);
